import React from 'react'
import styled from 'styled-components'

const BlackDiv = styled.div`
    background:rgb(40,40,40);
    color:rgba(220,220,220);
    grid-column:span 2;
    border-radius:10px;
    display:grid;
    width:100%;
    grid-template-columns:50% 50%;
    margin:5rem auto;
    margin-bottom:2rem;
    & h2{
        margin-top:2rem;
    }

    @media only screen and (max-width:600px){
        grid-template-columns:1fr;

        
    }
  `

export default props =><BlackDiv>{props.children}</BlackDiv>